import moment from 'moment';

import { CriticalDatesState } from './critical-dates-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import { Action, StateStatus } from '../reducers/utils/state-manager';

const InitialState: CriticalDatesState = {
  criticalDatesByOrgId: {},
  criticalDatesStateByOrgId: {},
};

const setCriticalDatesDirty = (state: CriticalDatesState, orgId: number) => ({
  ...state,
  criticalDatesByOrgId: {
    ...state.criticalDatesByOrgId,
    [orgId]: {},
  },
  criticalDatesStateByOrgId: {
    ...state.criticalDatesStateByOrgId,
    [orgId]: StateStatus.notAttempted,
  },
});

export const criticalDatesReducer = (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_ORG_CRITICAL_DATES'): {
      const { orgId } = action.payload.args;
      return {
        ...state,
        criticalDatesStateByOrgId: {
          ...state.criticalDatesStateByOrgId,
          [orgId]: StateStatus.loading,
        },
      };
    }
    case SUCCESS('LOAD_ORG_CRITICAL_DATES'): {
      const {
        args: { orgId, rangeStart, rangeEnd },
        data,
      } = action.payload;

      const criticalDatesByDate = data.reduce(
        (acc: { [date: string]: Array<CriticalDate> }, criticalDate: CriticalDate) => {
          const forDate = moment(criticalDate.startAt).format('YYYY-MM-DD');
          return { ...acc, [forDate]: [...(acc[forDate] || []), criticalDate] };
        },
        {},
      );
      // For any dates that we don't have events, return empty array, so we know it's been loaded there are just no matches
      for (let i = moment(rangeStart); i.isSameOrBefore(moment(rangeEnd)); i.add(1, 'days')) {
        if (!criticalDatesByDate[i.format('YYYY-MM-DD')]) {
          criticalDatesByDate[i.format('YYYY-MM-DD')] = [];
        }
      }

      return {
        ...state,
        criticalDatesByOrgId: {
          ...state.criticalDatesByOrgId,
          [orgId]: {
            ...state.criticalDatesByOrgId[orgId],
            ...criticalDatesByDate,
          },
        },
        criticalDatesStateByOrgId: {
          ...state.criticalDatesStateByOrgId,
          [orgId]: StateStatus.notAttempted,
        },
      };
    }
    case FAILURE('LOAD_ORG_CRITICAL_DATES'): {
      const { orgId } = action.payload.args;
      return {
        ...state,
        criticalDatesStateByOrgId: {
          ...state.criticalDatesStateByOrgId,
          [orgId]: StateStatus.error,
        },
      };
    }
    case SUCCESS('SET_HIRE_DATE'):
    case SUCCESS('SET_INTERVIEW'):
    case SUCCESS('UPDATE_START_DATE_TRIGGERED_COMMUNICATION'):
    case SUCCESS('CREATE_START_DATE_TRIGGERED_COMMUNICATION'):
    case SUCCESS('APPLICATION_STATUS'): {
      const { orgId } = action.payload.args;
      return setCriticalDatesDirty(state, orgId);
    }
    case SUCCESS('UPDATE_JOB_APPLICANT'): {
      const { orgId, update } = action.payload.args;
      if (typeof update.reachOutAlertDate !== undefined) {
        return setCriticalDatesDirty(state, orgId);
      }
      return state;
    }
    default: {
      return state;
    }
  }
};
